<template>
  <div>
    <el-form
      class="query-form"
      ref="refForm"
      :model="searchData"
      :size="size"
      :inline="inline"
      :label-width="labelWidth"
      v-bind="$attrs"
      label-position="right"
      v-on="$listeners"
      :class="isBackground ? 'query-form-new' : ''"
    >
      <template v-for="item in formInfo">
        <el-form-item
          :label="item.label"
          :key="item.prop"
          :prop="item.prop"
          class="form_item"
          :class="{
            'long-form': longTypeArr.includes(item.type),
            nobtm: removeBottom,
          }"
          :style="item.style"
          v-if="!item.notShow"
        >
          <!-- 自定义 -->
          <template #label v-if="item.slotLabel">
            <slot :name="item.slotLabel" :scope="item"></slot>
          </template>
          <template>
            <div v-if="item.slot">
              <slot :name="item.slot" :scope="item"></slot>
            </div>
            <div v-if="item.slotError">
              <slot :name="item.slotError" :scope="item"></slot>
            </div>
            <!-- 输入框 -->
            <el-input
              v-if="item.type === 'Input'"
              v-model="searchData[item.prop]"
              :style="{ width: item.width || width }"
              :placeholder="item.placeholder"
              :maxlength="item.maxlength"
              :show-word-limit="item.showWordLimit"
              @input="
                (val) =>
                  item.input
                    ? (searchData[item.prop] = item.input(val))
                    : () => {
                        return val;
                      }
              "
              @change="
                (val) =>
                  item.change
                    ? item.change(val)
                    : () => {
                        return val;
                      }
              "
            ></el-input>
            <!-- 联级选择器 -->
            <el-cascader
              v-else-if="item.type === 'cascader'"
              v-model="searchData[item.prop]"
              :show-all-levels="false"
              collapse-tags
              :options="item.options"
              :props="item.props"
              style="width: 290px"
            ></el-cascader>
            <!-- 双输入框 -->
            <template v-else-if="item.type === 'InputDouble'">
              <div :style="{ width: item.width || width }" class="input_flex">
                <el-input
                  v-model="searchData[item.startKey]"
                  class="input_item"
                  :placeholder="item.startPlaceholder"
                  style="width: 145px"
                  :type="item.inputType || 'text'"
                >
                  <template v-if="item.startSuffix" slot="suffix">
                    <div class="suffixBody">
                      <span>{{ item.startSuffix }}</span>
                    </div>
                  </template>
                </el-input>
                <span
                  style="margin: 0 4px; line-height: 32px"
                  class="time-span-text"
                  >至</span
                >
                <el-input
                  v-model="searchData[item.endKey]"
                  class="input_item"
                  :placeholder="item.endPlaceholder"
                  style="width: 145px"
                  :type="item.inputType || 'text'"
                >
                  <template v-if="item.endSuffix" slot="suffix">
                    <div class="suffixBody">
                      <span>{{ item.endSuffix }}</span>
                    </div>
                  </template>
                </el-input>
              </div>
            </template>
            <!-- 下拉框 -->
            <el-select
              v-else-if="item.type === 'Select'"
              v-model="searchData[item.prop]"
              :style="{ width: item.width || width }"
              @change="(e) => selectChange(e, item.prop)"
            >
              <el-option
                v-for="op in item.options"
                :label="op.label"
                :value="op.value"
                :key="op.value"
              ></el-option>
            </el-select>
            <!-- 单选 -->
            <el-radio-group
              v-else-if="item.type === 'Radio'"
              v-model="searchData[item.prop]"
              :style="{ width: item.width || width }"
            >
              <el-radio
                v-for="ra in item.options"
                :label="ra.value"
                :key="ra.value"
                :style="{ width: ra.width || 'auto' }"
                >{{ ra.label }}</el-radio
              >
            </el-radio-group>
            <!-- 单选按钮 -->
            <el-radio-group
              v-else-if="item.type === 'RadioButton'"
              v-model="searchData[item.prop]"
            >
              <el-radio-button
                v-for="ra in item.options"
                :label="ra.value"
                :key="ra.value"
                >{{ ra.label }}</el-radio-button
              >
            </el-radio-group>
            <!-- 复选框 -->
            <el-checkbox-group
              v-else-if="item.type === 'Checkbox'"
              v-model="searchData[item.prop]"
            >
              <el-checkbox v-if="item.all" label="不限" value=""></el-checkbox>
              <el-checkbox
                v-for="ch in item.options"
                :label="ch.value"
                :key="ch.value"
                >{{ ch.label }}</el-checkbox
              >
            </el-checkbox-group>
            <!-- 日期范围 -->
            <time-pick
              v-else-if="item.type === 'DateRange'"
              :type="item.dateType"
              :style="{ width: item.width || width }"
              :startTime.sync="searchData[item.startKey]"
              :endTime.sync="searchData[item.endKey]"
              :format="item.format"
              :defaultValueStart="item.defaultValueStart"
              :defaultValueEnd="item.defaultValueEnd"
              :defalutLimit="item.defalutLimit"
              :pickerOptionsStart="item.pickerOptionsStart"
              :pickerOptionsEnd="item.pickerOptionsEnd"
              @change="(time) => changeDate(time.startTime, time.endTime, item)"
            ></time-pick>
            <!-- 单选+自定义 -->
            <el-radio-group
              v-else-if="item.type === 'RadioCustom'"
              v-model="searchData[item.prop]"
            >
              <template v-for="ra in item.options">
                <el-radio :label="ra.value" :key="ra.value">
                  {{ ra.label }}
                </el-radio>
                <template v-if="ra.custom">
                  <el-input
                    :key="ra.value"
                    class="short-input"
                    size="small"
                    v-model="searchData[ra.startKey]"
                    type="text"
                    style="width: 120px"
                    :disabled="searchData[item.prop] != ra.value"
                  >
                    <span slot="suffix">{{ ra.unit }}</span>
                  </el-input>
                  <span
                    :key="ra.value"
                    style="display: inline-block; margin: 0 5px"
                    class="time-span-text"
                    >至</span
                  >
                  <el-input
                    :key="ra.value"
                    class="short-input"
                    size="small"
                    v-model="searchData[ra.endKey]"
                    type="number"
                    style="width: 120px"
                    :disabled="searchData[item.prop] != ra.value"
                  >
                    <span slot="suffix">{{ ra.unit }}</span>
                  </el-input>
                </template>
              </template>
            </el-radio-group>
            <!-- 单选+自定义日期范围 -->
            <el-radio-group
              v-else-if="item.type === 'RadioCustomDate'"
              v-model="searchData[item.prop]"
            >
              <template v-for="ra in item.options">
                <el-radio :label="ra.value" :key="ra.value">
                  {{ ra.label }}
                </el-radio>
                <template v-if="ra.custom">
                  <el-input
                    :key="ra.value"
                    class="short-input"
                    size="small"
                    v-model="searchData[ra.startKey]"
                    type="text"
                    style="width: 120px"
                    :disabled="searchData[item.prop] != ra.value"
                  >
                    <span slot="suffix">{{ ra.unit }}</span>
                  </el-input>
                  <span
                    :key="ra.value"
                    style="display: inline-block; margin: 0 5px"
                    class="time-span-text"
                    >至</span
                  >
                  <el-input
                    :key="ra.value"
                    class="short-input"
                    size="small"
                    v-model="searchData[ra.endKey]"
                    type="number"
                    style="width: 120px"
                    :disabled="searchData[item.prop] != ra.value"
                  >
                    <span slot="suffix">{{ ra.unit }}</span>
                  </el-input>
                </template>
              </template>
            </el-radio-group>
            <!-- 开关 -->
            <el-switch
              v-else-if="item.type === 'Switch'"
              v-model="searchData[item.prop]"
            ></el-switch>
          </template>
        </el-form-item>
      </template>

      <el-form-item v-if="btn30">
        <div style="margin-left: 14px">
          <y-button type="blue" v-if="handleSearchShow" @click="handleSearch">{{
            handleSearchText
          }}</y-button>
          <y-button
            :disabled="handleResetDisabled"
            v-if="!noReset"
            @click="handleReset"
            >{{ handleResetText }}</y-button
          >
        </div>
      </el-form-item>
      <el-form-item v-else :style="handleStyle">
        <div slot="label">
          <!-- 展开收起按钮 -->
          <template v-if="showExpandButton && isNeedToggle">
            <div @click="toggleExpand" class="btn-one2 btn-one_more2">
              <span
                style="cursor: pointer; margin-right: 4px"
                class="theme_color"
                >{{ isExpanded ? "收起" : "展开" }}</span
              >
              <i
                :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></i>
            </div>
          </template>
        </div>
        <div :style="{ marginLeft: showExpandButton ? '4px' : '' }">
          <y-button type="blue" v-if="handleSearchShow" @click="handleSearch">{{
            handleSearchText
          }}</y-button>
          <y-button
            :disabled="handleResetDisabled"
            v-if="!noReset"
            @click="handleReset"
            >{{ handleResetText }}</y-button
          >
        </div>
      </el-form-item>
      <!-- 按钮 -->
      <div
        class="button-box"
        :style="{
          left: btnLeft ? btnLeft : '',
          bottom: btnBottom ? btnBottom : '',
          top: btnTop ? btnTop : '',
        }"
        v-if="customBtnList.length > 0"
      >
        <template>
          <div v-for="(item, index) in customBtnList" :key="index">
            <div>
              <y-button
                :type="item.type"
                :size="item.size || size"
                @click="handleBtn(item)"
                >{{ item.label }}</y-button
              >
            </div>
          </div>
        </template>
      </div>

      <!-- 额外的按钮 -->
      <slot name="buttonOut"></slot>
    </el-form>
  </div>
</template>

<script>
import timePick from "./timePick.vue";

export default {
  components: {
    timePick,
  },
  props: {
    show: null,
    labelWidth: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "290px",
    },
    size: {
      type: String,
      default: "small",
    },
    inline: {
      type: Boolean,
      default: true,
    },
    isBackground: {
      type: Boolean,
      default: false,
    },
    formInfo: {
      type: Array,
      default: () => [],
    },
    // 自定义按钮列表
    customBtnList: {
      type: Array,
      default: () => [],
    },
    // 是否关闭重置按钮
    noReset: {
      type: Boolean,
      default: false,
    },
    // 是否立即触发
    immediately: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //查询区位置
    btnLeft: {
      type: String,
      default: "1350px",
    },
    btnTop: {
      type: String,
      default: null,
    },
    btnBottom: {
      type: String,
      default: null,
    },
    // 移除底部18px外边距 为不影响原有效果 默认为false
    removeBottom: {
      type: Boolean,
      default: false,
    },
    // 重置按钮自定义事件
    emitReset: {
      type: Boolean,
      default: false,
    },
    // 查询按钮文字
    handleSearchText: {
      type: String,
      default: "查询",
    },
    //重置按钮文字
    handleResetText: {
      type: String,
      default: "重置",
    },
    // 重置按钮禁用
    handleResetDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示查询按钮
    handleSearchShow: {
      type: Boolean,
      default: true,
    },
    // 是否按钮只和最后一项距离30px
    btn30: {
      type: Boolean,
      default: false,
    },
    isNeedToggle: {
      // 是否需要展开收起操作
      type: Boolean,
      default: false,
    },
    handleStyle: Object, // 自定义操作区域样式
  },
  mounted() {
    this.$nextTick(() => {
      // 计算行数
      let rowCount = this.calculateRowCount();
      this.showExpandButton = rowCount > 2;
    });
    this.reData();
    if (this.immediately) {
      this.handleSearch();
    }
  },
  watch: {},
  data() {
    return {
      isSku: false,
      searchData: {},
      longTypeArr: ["RadioCustom", "City"],
      isExpanded: false, // 展开状态
      showExpandButton: false, // 是否显示展开按钮
    };
  },
  computed: {
    // 计算显示的表单项
    displayFormInfo() {
      if (this.showExpandButton && !this.isExpanded) {
        // 未展开时显示前两行
        let count = 0;
        let result = [];
        for (let item of this.formInfo) {
          if (count >= 2) break;
          result.push(item);
          if (this.isNewRow(item)) count++;
        }
        return result;
      }
      return this.formInfo;
    },
  },
  methods: {
    // 手动重置数据 用于给父组件ref调用及减少重复代码
    reData() {
      let obj = this.getInitForm();
      Object.keys(obj).forEach((item) => {
        this.$set(this.searchData, item, obj[item]);
      });
    },
    // 抛出选择器选中事件
    selectChange(e, key) {
      this.$emit("selectChange", {
        key, //当前选择器的key
        val: e, //选中的val
      });
      this.$forceUpdate();
    },
    handleSearch() {
      this.$emit("update:formData", { ...this.formData, ...this.searchData });
      let params = { ...this.searchData };
      this.$emit("search", params);
    },
    handleReset() {
      // 自定义事件后不重置
      if (!this.emitReset) {
        this.reData();
      }
      //end
      this.$emit("selfReset");
      this.$emit("update:formData", { ...this.formData, ...this.searchData });
      this.$emit(this.emitReset ? "reset" : "search", this.searchData);
    },
    handleBtn(item) {
      this.$emit(item.handle, this.searchData);
    },
    setFormData(data) {
      // 设置表单数据，用于初始化表单
      this.searchData = { ...this.searchData, ...data };
    },
    getSearchForm() {
      return this.searchData;
    },
    changeDate(start, end, item) {
      console.log(start, end, item);
      this.$set(this.searchData, item.startKey, start);
      this.$set(this.searchData, item.endKey, end);
      this.$forceUpdate();
    },
    // 判断是不是undefined
    isUndefined(val) {
      if (val == undefined) return null;
      else return val;
    },

    // 获取初始化对象
    getInitForm() {
      // this.$refs.refForm.resetFields();
      let formObj = {};
      this.formInfo.map((item) => {
        if (item.type == "DateRange") {
          if (!!item.lastDay || item.lastDay === 0) {
            formObj[item.startKey] = this.getLastTime(item.lastDay);
            if (item.noEndTime) {
              formObj[item.endKey] = null;
            } else {
              formObj[item.endKey] = this.getLastTime(0);
            }
          } else {
            formObj[item.startKey] = this.isUndefined(item.startTime);
            formObj[item.endKey] = this.isUndefined(item.endTime);
          }
        } else if (item.type == "InputDouble") {
          formObj[item.startKey] = this.isUndefined(item.startValue);
          formObj[item.endKey] = this.isUndefined(item.endValue);
        } else if (item.type == "RadioCustom") {
          formObj[item.prop] = this.isUndefined(item.value);
          item.options &&
            item.options.forEach((ra) => {
              if (ra.custom) {
                formObj[ra.startKey] = this.isUndefined(ra.startValue);
                formObj[ra.endKey] = this.isUndefined(ra.endValue);
              }
            });
        } else if (item.type == "City") {
          formObj[item.prop] = this.isUndefined(item.value);
          formObj[item.customKey] = item.customValue || [];
        } else {
          formObj[item.prop] = this.isUndefined(item.value);
        }
      });
      return { ...formObj };
    },
    // 获取最近 last 天时间 格式 yyyy-mm-dd
    getLastTime(last) {
      let count = Number(last);
      const date = new Date(Date.now() - count * 24 * 60 * 60 * 1000);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      console.log("last", date, `${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    },
    // 切换展开状态
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      console.log("this.isExpanded", this.isExpanded);
      this.$emit("toggleExpand", this.isExpanded);
    },
    // 计算行数
    calculateRowCount() {
      let count = 1;
      let lastBottom = 0;
      const formItems = this.$el.querySelectorAll(".form_item");
      formItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top > lastBottom) {
          count++;
          lastBottom = rect.bottom;
        }
      });
      return count;
    },
    // 判断是否新行
    isNewRow(item) {
      return item.type === "RadioCustom" || item.type === "City";
    },
  },
};
</script>

<style lang="scss" scoped>
.time-span-text {
  font-size: 12px;
}
.button-box {
  position: absolute;
  bottom: 16px;
}
.query-form {
  position: relative;
  background: #f8f8f8;
  padding: 16px 16px 0 16px;
  box-sizing: border-box;
  border-radius: 4px 4px 4px 4px;
}
.query-form-new {
  background: transparent !important;
  padding: 16px 16px 0 0 !important;
  margin-left: -23px;
}
.nobtm {
  margin-bottom: 0;
}
.form_item {
  margin-right: 16px !important;
  margin-bottom: 16px !important;
}

.input_flex {
  display: flex;
  align-items: center;
}

.long-form .el-form-item {
  display: flex;
  width: 100% !important;
  align-items: flex-start;
  .el-form-item__label {
    // width: 100px;
    padding: 0;
  }
  .el-form-item__content {
    flex: 1;
    // width: auto;
    .el-input__suffix {
      line-height: 32px;
    }
  }
  .el-form-item__content > :first-child {
    width: 100%;
  }
}
/deep/ .el-form-item__label {
  padding: 0 0 0 12px !important;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  min-width: 84px;
}
.suffixBody {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  height: 100%;
  padding: 0 12px;
  border-left: 1px solid rgba(236, 236, 236, 1);
}
::v-deep .el-input .el-input__inner {
  font-size: 12px !important;
}
::v-deep .el-input--small .el-input__icon {
  width: 12px !important;
}

.btn-one2 {
  width: 56px;
  height: 32px;
  opacity: 1;
  font-size: 12px;
  font-weight: 400;
  line-height: 32px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.btn-one_more2 {
  height: 32px;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  color: #364ecf;
}
</style>
